import React, { useState, useEffect, useRef } from "react";
import {
  AddIcon,
  AppsIcon,
  Avatar,
  AvatarContainer,
  DraftsIcon,
  ExpandLessIcon,
  FeedbackIcon,
  FiberManualRecordIcon,
  FileCopyIcon,
  NotesIcon,
  HomeIcon,
  Main,
  PeopleAltIcon,
  SidebarContainer,
  SidebarHeader,
  SidebarInfo,
  SidebarMain,
  SidebarUserName,
  LogoutButton,
  HelpOutlineIcon,
  SidebarLogOut,
  SidebarOptionMenu,
  ShowLessButton,
  ExpandMoreIcon,
  SidebarLink,
  MailIcon,
} from "./SidebarStyle.js";
import SidebarOption from "./SidebarOption/SidebarOption";
import db from "../firebase";
import { useStateValue } from "../StateProvider";
import { auth, provider } from "../firebase";
import { actionTypes } from "../reducer";
import { Link } from "react-router-dom";

function Sidebar({ sidebarOpen, setSidebarOpen, toggle }) {
  const [channels, setChannels] = useState([]);
  const [{ user }, dispatch] = useStateValue();
  const [sidebarOptionMenuOpen, setSidebarOptionMenuOpen] = useState(false);

  const sidebarOptionMenuToggle = () =>
    setSidebarOptionMenuOpen(!sidebarOptionMenuOpen);

  const logout = () => {
    auth
      .signOut()
      .then(() => {
        dispatch({
          type: actionTypes.SET_USER,
          user: null,
        });
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  useEffect(() => {
    db.collection("rooms").onSnapshot((snapshot) =>
      setChannels(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          name: doc.data().name,
        }))
      )
    );
  }, []);

  return (
    <Main>
      <SidebarContainer sidebarOpen={sidebarOpen}>
        <SidebarHeader>
          <AvatarContainer>
            <Link to="/userinfo" onClick={() => setSidebarOpen(false)}>
              <Avatar
                className="header__avatar"
                alt={user?.displayName}
                src={user?.photoURL}
              />
              <FiberManualRecordIcon />
            </Link>
          </AvatarContainer>

          <SidebarInfo>
            <SidebarUserName>{user?.displayName}</SidebarUserName>
          </SidebarInfo>
          <SidebarLogOut>
            {user ? (
              <LogoutButton onClick={logout}>Logout</LogoutButton>
            ) : (
              <HelpOutlineIcon />
            )}
          </SidebarLogOut>
        </SidebarHeader>

        <SidebarLink to="/home" onClick={() => setSidebarOpen(false)}>
          <HomeIcon />
          <h3>Home</h3>
        </SidebarLink>

        <SidebarLink to="/notes" onClick={() => setSidebarOpen(false)}>
          <NotesIcon />
          <h3>Notes</h3>
        </SidebarLink>

        <SidebarLink to="/Drafts" onClick={() => setSidebarOpen(false)}>
          <DraftsIcon />
          <h3>Drafts</h3>
        </SidebarLink>

        <SidebarLink to="/Inbox" onClick={() => setSidebarOpen(false)}>
          <MailIcon />
          <h3>Inbox</h3>
        </SidebarLink>

        <SidebarOptionMenu sidebarOptionMenuOpen={sidebarOptionMenuOpen}>
          <SidebarLink to="/Associates" onClick={() => setSidebarOpen(false)}>
            <PeopleAltIcon />
            <h3>Associates</h3>
          </SidebarLink>

          <SidebarLink to="/Apps" onClick={() => setSidebarOpen(false)}>
            <AppsIcon />
            <h3>Apps</h3>
          </SidebarLink>

          <SidebarLink to="/Components" onClick={() => setSidebarOpen(false)}>
            <FileCopyIcon />
            <h3>Components</h3>
          </SidebarLink>

          <SidebarLink to="/feedback" onClick={() => setSidebarOpen(false)}>
            <FeedbackIcon />
            <h3>Leave us feedback</h3>
          </SidebarLink>
        </SidebarOptionMenu>

        <ShowLessButton
          onClick={sidebarOptionMenuToggle}
          sidebarOptionMenuOpen={sidebarOptionMenuOpen}
        >
          {sidebarOptionMenuOpen ? (
            <>
              <span>Show Less </span> <ExpandLessIcon />
            </>
          ) : (
            <>
              <span>Show More </span> <ExpandMoreIcon />
            </>
          )}
        </ShowLessButton>

        <SidebarMain>
          <SidebarOption
            id="addchannel"
            Icon={AddIcon}
            addChannelOption
            title="Add Channel"
          />
          {channels.map((channel) => (
            <SidebarOption title={channel.name} id={channel.id} />
          ))}
        </SidebarMain>
      </SidebarContainer>
    </Main>
  );
}

export default Sidebar;
